<template>
    <div class="node-properties-inner">
        <select v-model="properties.classKey">
            <option value="coloured-dots">Coloured Dots</option>
            <option value="trucks">Trucks</option>
            <option value="cars">Cars</option>
            <option value="handhelds">Handhelds</option>
            <option value="base">Base</option>
            <option value="telemetry-units">Telemetry Units</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>
